"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _App = _interopRequireDefault(require("./components/App"));
var _storeProvider = require("./util/storeProvider");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _breakpoint = require("./util/breakpoint");
require("./styles/globals");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class ConfigPage extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      store: this.props.store
    };
    this.state.postComplete = this.props.store.getState('app').postComplete;
    this.state.breakpoint = (0, _breakpoint.getBreakpoint)();
    this.state.isMobile = (0, _breakpoint.isMobile)();
    this.state.isBrowser = typeof window !== 'undefined';
    this.postCompleteFocus;
    this.subscriptionId;
    this.onStoreAppChange = this.onStoreAppChange.bind(this);
    this.handleResize = (0, _lodash.default)(this.handleResize.bind(this), 100);
  }
  onStoreAppChange(newState) {
    if (!newState.postComplete) {
      this.postCompleteFocus = document.activeElement;
    }
    this.setState({
      postComplete: newState.postComplete
    }, () => {
      if (this.state.postComplete) {
        if (this.postCompleteFocus && typeof this.postCompleteFocus.focus === 'function') {
          this.postCompleteFocus.focus();
        }
        this.postCompleteFocus = null;
      }
    });
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.subscriptionId = this.props.store.subscribe('app', this.onStoreAppChange);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.props.store.unsubscribe(this.subscriptionId);
  }
  handleResize() {
    this.setState({
      breakpoint: (0, _breakpoint.getBreakpoint)()
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(_storeProvider.Provider, {
      value: this.state
    }, /*#__PURE__*/React.createElement(_App.default, {
      includeState: [{
        path: 'app'
      }]
    }));
  }
}
ConfigPage.propTypes = {
  store: _propTypes.default.object
};
var _default = exports.default = ConfigPage;